import { render, staticRenderFns } from "./annex.vue?vue&type=template&id=742bae8e&scoped=true"
import script from "./annex.vue?vue&type=script&lang=js"
export * from "./annex.vue?vue&type=script&lang=js"
import style0 from "./annex.vue?vue&type=style&index=0&id=742bae8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742bae8e",
  null
  
)

export default component.exports